var exports = {
  "kL": "NameStyleSettings.module__container___M1hFT1",
  "wx": "NameStyleSettings.module__header___M1hFT1",
  "DD": "NameStyleSettings.module__title___M1hFT1",
  "h_": "NameStyleSettings.module__description___M1hFT1",
  "VH": "NameStyleSettings.module__preview___M1hFT1",
  "gz": "NameStyleSettings.module__previewName___M1hFT1",
  "G7": "NameStyleSettings.module__previewHint___M1hFT1",
  "bk": "NameStyleSettings.module__fieldLabel___M1hFT1",
  "Fv": "NameStyleSettings.module__categoryRow___M1hFT1",
  "Hv": "NameStyleSettings.module__categoryButton___M1hFT1",
  "_K": "NameStyleSettings.module__categoryButtonSelected___M1hFT1",
  "qW": "NameStyleSettings.module__fontGrid___M1hFT1",
  "Sy": "NameStyleSettings.module__fontTile___M1hFT1",
  "JM": "NameStyleSettings.module__fontTileSelected___M1hFT1",
  "s_": "NameStyleSettings.module__fontSample___M1hFT1",
  "AG": "NameStyleSettings.module__fontLabel___M1hFT1",
  "Vc": "NameStyleSettings.module__scriptChips___M1hFT1",
  "Ks": "NameStyleSettings.module__scriptChip___M1hFT1",
  "Tj": "NameStyleSettings.module__colors___M1hFT1",
  "WA": "NameStyleSettings.module__resetButton___M1hFT1",
};

module.exports = exports;
